module.exports = __webpack_public_path__ + "static/media/banner-create.c63eab2a.svg";